// extracted by mini-css-extract-plugin
module.exports = {"mobileImage":"GamingPromotionBanner_mobileImage__1gCws","desktopImage":"GamingPromotionBanner_desktopImage__oB6Iv","close":"GamingPromotionBanner_close__5y59z"};